<edt-layout-base
  sideNavMode="side"
  [containerTheme]="containerTheme"
  [footerTheme]="footerTheme"
  [alwaysShowToggle]="true"
>
  <!-- MENU -->
  <div sidenavheader class="side-header container-fluid h-100">
    <span>Te llevo</span>
  </div>
  <div sidenavmenuleft class="side-body">
    <edt-sidenav></edt-sidenav>
  </div>
  <!-- CONTENT AREA -->
  <edt-header
    contentheader
    [canShow]="canShow"
    [logoImg]="''"
  ></edt-header>
  <div headertoggle class="side-toggle">
    <div class="container-fluid p-0 h-100">
      <div class="row align-items-center justify-content-center g-0 h-100">
        <div class="col p-0">
          <button type="button" aria-label="Toggle sidenav" mat-icon-button>
            <mat-icon
              class="d-flex"
              svgIcon="menu"
              aria-label="Side nav toggle icon"
            ></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div contentcontainer>
    <router-outlet></router-outlet>
  </div>
  <edt-footer contentfooter></edt-footer>
</edt-layout-base>
